module.exports = __webpack_public_path__ + "img/jingdiangonglue.9c4e77ce.png";